import styled from 'styled-components';

export const RatingWrapper = styled.div`
    padding: 2px 0;
    font-size: 0.8rem;
    margin-bottom: 7px;
`;

export const RatingHeadingWrapper = styled.div`
    display: flex;
    justify-content: left;
    flex: 0 0 60%;
    align-items: center;
`;

export const RatingAndCommentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 2px;
`;

export interface IInputProps {
    isValid?: boolean;
}

export const StringInputWrapper = styled.div<IInputProps>`
    display: flex;
    flex: 0 0 50%;
    justify-content: flex-end;
    align-items: center;
    font-size: 0.9rem;
    height: max-content;

    ${({ isValid }) =>
        !isValid &&
        `
    border-left: 3px solid #a94442; /* red */
  `}

    ${({ isValid }) =>
        isValid &&
        `
    border-left: 3px solid #25982e; /* green */
  `}
`;

export const RatingInputOuterWrapper = styled.div``;

export const RatingInputWrapper = styled.div<IInputProps>`
    ${({ isValid }) =>
        !isValid &&
        `
    border-left: 3px solid #a94442; /* red */
  `}

    ${({ isValid }) =>
        isValid &&
        `
    border-left: 3px solid #25982e; /* green */
  `}
`;
